<template>
  <div class="user-page">
    <div class="user-body container">
      <base-info></base-info>
      <user-tab></user-tab>
    </div>
    <!-- 主动弹窗 -->
    <user-popup-dialog ref="userPopupDialog"></user-popup-dialog>
  </div>
</template>

<script>
import BaseInfo from './components/base-info.vue';
import UserPopupDialog from './components/user-popup-dialog.vue';
import UserTab from './components/user-tab.vue';

export default {
  name: 'user',
  components: {
    BaseInfo,
    UserTab,
    UserPopupDialog,
  },
  data() {
    return {
    };
  },
  computed: {
  },
  methods: {

  },
  mounted() {
    this.$refs.userPopupDialog.initPopupDialog();
  },
};
</script>

<style lang="less">
.user-page{
  padding: 20px 0;
  .container{
    width: 1120px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/User.vue